// extracted by mini-css-extract-plugin
export var attachment = "_rt-a";
export var emailContainer = "_rt-4";
export var emailContentPaddedContainer = "_rt-b";
export var emailHeader = "_rt-6";
export var emailIframe = "_rt-3";
export var emailInfoIcon = "_rt-9";
export var emailShortenedSummary = "_rt-e";
export var infoDropdown = "_rt-0";
export var infoRowBoundedContent = "_rt-d";
export var internal = "_rt-5";
export var merchant = "_rt-8";
export var messageInputContainer = "_rt-h";
export var normal = "_rt-7";
export var replyCard = "_rt-f";
export var subtleButton = "_rt-1";
export var subtleButtonIconContainer = "_rt-2";
export var toggleViewRepliesButton = "_rt-c";
export var wrappingText = "_rt-g";